import { formatAddress, streetLineFromFullAddress } from "@/utils/stringUtils";

/**
 * Resolves a property record for inbox/snackbar copy when a process notification carries `propertyId`.
 *
 * @param {{ getProperty: (customer: string, propertyId: unknown) => Object|null }} propertyDetailsStore
 * @param {{ listCustomer?: string|null, listProperties?: Array<Object> }} propertyListStore
 * @param {string} customer - Active tenant id from auth
 * @param {unknown} propertyId
 * @returns {Object|null}
 */
export function resolvePropertyRecordForNotification(
  propertyDetailsStore,
  propertyListStore,
  customer,
  propertyId
) {
  if (!customer || propertyId == null) return null;
  const pid = String(propertyId).trim();
  if (!pid) return null;

  const fromCache = propertyDetailsStore.getProperty(customer, propertyId);
  if (fromCache) return fromCache;

  if (propertyListStore?.listCustomer === customer && Array.isArray(propertyListStore.listProperties)) {
    return propertyListStore.listProperties.find((p) => String(p?.id) === pid) ?? null;
  }

  return null;
}

/**
 * Appends a formatted street line to a process notification message when safe to show.
 *
 * @param {string} message
 * @param {Object|null} propertyRecord
 * @returns {string}
 */
export function augmentProcessNotificationMessageWithStreet(message, propertyRecord) {
  const base = typeof message === "string" ? message.trim() : "";
  if (!base) return typeof message === "string" ? message : "";

  if (!propertyRecord || typeof propertyRecord !== "object" || propertyRecord.hidden_address) {
    return message;
  }

  const rawStreet = streetLineFromFullAddress(propertyRecord.full_address ?? "");
  if (!rawStreet) return message;

  const streetLabel = formatAddress(rawStreet, false);
  if (!streetLabel) return message;

  return `${base} — ${streetLabel}`;
}
